import axios from "axios"

//pass new generated access token here
const token = sessionStorage.getItem("accessToken")

//apply base url for axios
const API_URL = process.env.REACT_APP_BASEURL

const axiosApi = axios.create({
  baseURL: API_URL,
})

axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  return returnaxiosApi
    .get(url, { ...config })
    .then(response => response.data)
    .catch(error => {
      throw error
    })
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(error => {
      throw error
    })
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(error => {
      throw error
    })
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
    .catch(error => {
      throw error
    })
}
